import { useOrderPresences } from '@hooks';
import { Alert } from 'antd';
import { observer } from 'mobx-react';

interface IProps {
  orderId: string;
}

export const OrderPresenceAlert: React.FC<IProps> = observer(({ orderId }) => {
  const { presenceLoading, presences } = useOrderPresences(orderId);

  if (presenceLoading) return null;

  if (presences.size === 0) return null;

  return (
      <Alert
        showIcon
        type="error"
        style={{marginTop: 10, marginBottom: 10}}
        description={`Warning: ${Array.from(presences.values())
          .map((p) => p.user?.fullname)
          .join(
            ', '
          )} is editing the job card. Please wait until they finish before making changes or saving.`}
      />
  );
});
